import React from 'react';
import "./BlogPost.css";
import med1 from '../../Assets/b68/med1.jpg';
import med2 from '../../Assets/b68/med2.jpg';
import med3 from '../../Assets/b68/med3.jpg';

function Blog68(){
  return (
    <>
      <div className='container-fluid my-5'>
        <div className='row mb-5'>
          <div className='col blog-text text-center'>
            <h1>Transforming Healthcare Management, One Specialized Tool at a Time.</h1>
            <h6>February 28, 2026 at 12:00 PM</h6>
          </div>
        </div>

        <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
          <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
            <div id="blogImages" className="carousel carousel-dark slide mx-auto" data-bs-ride="true" data-bs-interval='3000'>
              <div className="carousel-indicators">
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="2" aria-label="Slide 3"></button>
              </div>
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <img src={med1} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={med2} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={med3} className="blog-img" alt="..."/>
                </div>
              </div>
              <button className="carousel-control-prev" type="button" data-bs-target="#blogImages" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#blogImages" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
            <p>At MYT Softdev Solutions, we believe that smarter records lead to brighter futures. Our suite of medical software is designed to streamline workflows, reduce paperwork, and let you focus on what matters most: patient care.</p>
            <p>
            •   𝗠𝗬𝗧 𝗗𝗶𝗮𝗴𝗻𝗼𝗦𝘆𝘀: Real-time tracking for sales, services, and comprehensive reporting.
            •   𝗠𝗲𝗱𝗘𝗮𝘀𝗲 𝗣𝗲𝗱𝗶𝗮: A digital "Baby Book" featuring growth charts and vaccine management.
            •   𝗠𝗲𝗱𝗘𝗮𝘀𝗲 𝗗𝗼𝗰: Smart clinic solutions including e-prescriptions and patient assessment history.
            </p>
            <p>From pediatric clinics to full-scale diagnostic centers, we provide the digital infrastructure your practice deserves.</p>
            <p><a href='https://www.facebook.com/hashtag/mytsoftdevsolutions' target='_blank' className='blog-link'>
              #MYTSoftDevSolutions</a>
              <a href='https://www.facebook.com/hashtag/techforgood' target='_blank' className='blog-link'>
              #TechForGood </a>
              <a href='https://www.facebook.com/hashtag/buildtolast' target='_blank' className='blog-link'>
              #BuildToLast</a>
              <a href='https://www.facebook.com/hashtag/medeasebymyt' target='_blank' className='blog-link'>
              #MedEaseByMYT</a></p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Blog68;